import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=5bc44029"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"
import style0 from "./Budget.vue?vue&type=style&index=0&id=5bc44029&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports